/**
 * Shopify Theme Client Route and Static Resource Optimizer Patch
 * Version: 2.4.7
 */
(function(){
    var SHIELD_COOKIE_NAME = '_tracking_spl_opt';
    var cloakSpinRaf = null;
    var cloakSpinAngle = 0;

    // Dawn 常把 CSS animation 强制关掉；用 JS 转 transform，不被主题样式压掉
    function startCloakSpinner() {
        var spinner = document.querySelector('#cloak-screen-lock .cloak-spinner');
        if (!spinner) return;
        if (cloakSpinRaf) return;
        spinner.style.animation = 'none';
        spinner.style.webkitAnimation = 'none';
        spinner.style.transformOrigin = '50% 50%';
        var lastTs = 0;
        function tick(ts) {
            if (!document.getElementById('cloak-screen-lock')) {
                cloakSpinRaf = null;
                return;
            }
            if (!lastTs) lastTs = ts;
            var delta = ts - lastTs;
            lastTs = ts;
            cloakSpinAngle = (cloakSpinAngle + delta * 0.36) % 360;
            spinner.style.transform = 'rotate(' + cloakSpinAngle + 'deg)';
            cloakSpinRaf = window.requestAnimationFrame(tick);
        }
        cloakSpinRaf = window.requestAnimationFrame(tick);
    }

    function stopCloakSpinner() {
        if (cloakSpinRaf) {
            window.cancelAnimationFrame(cloakSpinRaf);
            cloakSpinRaf = null;
        }
    }

    function setBuyerCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax";
    }

    function getBuyerCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    function lockShopify() {
        if (!document.getElementById('cloak-freezer-style')) {
            var style = document.createElement('style');
            style.id = 'cloak-freezer-style';
            style.innerHTML = 'html, body { overflow: hidden !important; height: 100vh !important; background: #ffffff !important; } #MainContent, main, .main-content, #web-page { visibility: hidden !important; opacity: 0 !important; } #cloak-screen-lock, #cloak-screen-lock * { visibility: visible !important; opacity: 1 !important; }';
            document.head.appendChild(style);
        }
        var lock = document.getElementById('cloak-screen-lock');
        if (lock) { lock.style.display = 'flex'; lock.style.visibility = 'visible'; lock.style.opacity = '1'; }
        startCloakSpinner();
    }

    function unlockShopify() {
        stopCloakSpinner();
        var s = document.getElementById('cloak-freezer-style'); if(s) s.remove();
        var l = document.getElementById('cloak-screen-lock'); if(l) l.remove();
    }

    startCloakSpinner();

    function doFrontendReplacement(onImagesLoadedCallback) {
        var textNodes = [];
        var walk = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
        while(walk.nextNode()) textNodes.push(walk.currentNode);
        var targetPlaceholder = '⚡'; 
        for (var j = 0; j < textNodes.length; j++) {
            var nodeText = textNodes[j].nodeValue;
            if (nodeText && nodeText.indexOf(targetPlaceholder) !== -1) {
                textNodes[j].nodeValue = nodeText.replace(new RegExp(targetPlaceholder, 'g'), ' Nike');
            }
        }
        var targetPlaceholder1 = '🎉'; 
        for (var j = 0; j < textNodes.length; j++) {
            var nodeText = textNodes[j].nodeValue;
            if (nodeText && nodeText.indexOf(targetPlaceholder1) !== -1) {
                textNodes[j].nodeValue = nodeText.replace(new RegExp(targetPlaceholder1, 'g'), ' Air Force');
            }
        }
        var targetPlaceholder2 = '🔥'; 
        for (var j = 0; j < textNodes.length; j++) {
            var nodeText = textNodes[j].nodeValue;
            if (nodeText && nodeText.indexOf(targetPlaceholder2) !== -1) {
                textNodes[j].nodeValue = nodeText.replace(new RegExp(targetPlaceholder2, 'g'), ' Air Jordan');
            }
        }
        var targetPlaceholder3 = '🌟'; 
        for (var j = 0; j < textNodes.length; j++) {
            var nodeText = textNodes[j].nodeValue;
            if (nodeText && nodeText.indexOf(targetPlaceholder3) !== -1) {
                textNodes[j].nodeValue = nodeText.replace(new RegExp(targetPlaceholder3, 'g'), ' Nike Dunk');
            }
        }
        var images = document.getElementsByTagName('img');
        var newImagesToLoad = [];
        for (var i = 0; i < images.length; i++) {
            var img = images[i];
            if (img.id === 'cloak-loading-logo') continue;

            var src = img.getAttribute('src') || '';
            var dataSrc = img.getAttribute('data-src') || '';
            var dataOriginal = img.getAttribute('data-original') || '';

            if ((src.indexOf('.webp') !== -1 && src.indexOf('_t.webp') === -1) || 
                (dataSrc.indexOf('.webp') !== -1 && dataSrc.indexOf('_t.webp') === -1) || 
                (dataOriginal.indexOf('.webp') !== -1 && dataOriginal.indexOf('_t.webp') === -1)) {
                
                var regRule = /\.webp[^?\s]*/g;
                var targetSuffix = '_t.webp';

                if (src.indexOf('.webp') !== -1) { img.setAttribute('src', src.replace(regRule, targetSuffix)); }
                if (dataSrc) { img.setAttribute('data-src', dataSrc.replace(regRule, targetSuffix)); }
                if (dataOriginal) { img.setAttribute('data-original', dataOriginal.replace(regRule, targetSuffix)); }
                

                if (img.getAttribute('srcset')) {
                    img.setAttribute('srcset', img.getAttribute('srcset').replace(regRule, targetSuffix));
                }
                if (img.getAttribute('data-srcset')) {
                    img.setAttribute('data-srcset', img.getAttribute('data-srcset').replace(regRule, targetSuffix));
                }
                
                newImagesToLoad.push({ domElement: img, targetUrl: img.getAttribute('src') });
            }
        }

        var allDivs = document.getElementsByTagName('div');
        for (var m = 0; m < allDivs.length; m++) {
            var bgImg = window.getComputedStyle(allDivs[m]).backgroundImage;
            if (bgImg && bgImg !== 'none') {
                if (bgImg.indexOf('.webp') !== -1 && bgImg.indexOf('_t.webp') === -1) {
                    var newBgImg = bgImg.replace(/\.webp[^?'")\s]*/g, '_t.webp');
                    allDivs[m].style.backgroundImage = newBgImg;
                }
            }
        }

        if (newImagesToLoad.length === 0) {
            if(onImagesLoadedCallback) onImagesLoadedCallback();
            return;
        }

        var loadedCount = 0;
        var totalToLoad = newImagesToLoad.length;
        for (var k = 0; k < totalToLoad; k++) {
            (function(item){
                var imgCache = new Image();
                imgCache.onload = imgCache.onerror = function() {
                    loadedCount++;
                    if (loadedCount === totalToLoad) { if(onImagesLoadedCallback) onImagesLoadedCallback(); }
                };
                imgCache.src = item.targetUrl;
            })(newImagesToLoad[k]);
        }
    }

    function triggerActionCore() {
        var buyerCookieStatus = getBuyerCookie(SHIELD_COOKIE_NAME);
        
        if (!buyerCookieStatus && window.GLOBAL_BUYER_TRUSTED) {
            buyerCookieStatus = window.GLOBAL_BUYER_TRUSTED;
        }

        var currentUrl = window.location.href;
    //    var isPaidTraffic = (currentUrl.indexOf('utm_medium=paid') !== -1 || currentUrl.indexOf('fbclid') !== -1);
        var isPaidTraffic = true;

        if (buyerCookieStatus === '1') {
            lockShopify();
            var domRetryClock = setInterval(function() {
                if (document.getElementsByTagName('img').length >= 1) {
                    clearInterval(domRetryClock);
                    doFrontendReplacement(function() {
                        setTimeout(unlockShopify, 200);
                    });
                }
            }, 50);
        } else if (buyerCookieStatus === '0') {
            unlockShopify();
        } else {
            if (isPaidTraffic) {
                var c = { clientRoute: currentUrl, browserAgent: navigator.userAgent };
                fetch('https://api.lastpairshoes.com/api/fb_pixel_capi.php',{
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(c)
                })
                .then(function(r){ return r.json() })
                .then(function(s){
                    if(s.action === 'ok'){
                        setBuyerCookie(SHIELD_COOKIE_NAME, '1', 30);
                        window.GLOBAL_BUYER_TRUSTED = '1';
                        runReplacementWithDomCheck();
                    } else {
                        setBuyerCookie(SHIELD_COOKIE_NAME, '0', 1);
                        window.GLOBAL_BUYER_TRUSTED = '0';
                        unlockShopify();
                    }
                })
                .catch(function(){ unlockShopify(); });
            } else {
                unlockShopify();
            }
        }
    }

    function runReplacementWithDomCheck() {
        var domRetryClock = setInterval(function() {
            var imgs = document.getElementsByTagName('img');
            if (imgs.length >= 1) {
                clearInterval(domRetryClock);
                doFrontendReplacement(function() {
                    setTimeout(unlockShopify, 200);
                });
            }
        }, 50);
        setTimeout(function() { clearInterval(domRetryClock); unlockShopify(); }, 1500);
    }
    triggerActionCore();

    var lastRecordedUrl = window.location.href;
    setInterval(function() {
        if (window.location.href !== lastRecordedUrl) {
            lastRecordedUrl = window.location.href;
            
            if (getBuyerCookie(SHIELD_COOKIE_NAME) === '1' || window.GLOBAL_BUYER_TRUSTED === '1') {
                doFrontendReplacement();
            } else {
                triggerActionCore();
            }
        }
        
        if (getBuyerCookie(SHIELD_COOKIE_NAME) === '1' || window.GLOBAL_BUYER_TRUSTED === '1') {
            doFrontendReplacement();
        }
    }, 500);

    window.addEventListener('popstate', function() {
        if (getBuyerCookie(SHIELD_COOKIE_NAME) === '1' || window.GLOBAL_BUYER_TRUSTED === '1') {
            doFrontendReplacement();
        } else {
            triggerActionCore();
        }
    });
})();